import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encodedUrl = params.get('url');

    if (!encodedUrl) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    const decodedUrl = decodeURIComponent(encodedUrl);

    axios
      .get(decodedUrl)
      .then(() => {
        setStatus('success');
        setMessage('Your email has been verified successfully!');
      })
      .catch((error) => {
        setStatus('error');
        setMessage(
          error.response?.data?.message || 'Verification failed or the link has expired.'
        );
      });
  }, []);

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-xl shadow-md text-center max-w-md w-full">
        {status === 'success' && (
          <FaCheckCircle className="text-green-500 text-5xl mb-4 mx-auto" />
        )}
        {status === 'error' && (
          <FaTimesCircle className="text-red-500 text-5xl mb-4 mx-auto" />
        )}
        <h2 className="text-2xl font-semibold mb-2">Verify Your Email</h2>
        <p className="text-gray-600 mb-4">{message}</p>
        {(status === 'success' || status === 'error') && (
          <button
            onClick={handleLoginRedirect}
            className="mt-4 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition"
          >
            Go to Login
          </button>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
